import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext,
  Suspense,
} from "react";
import { Link } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { MultiSelect } from "primereact/multiselect";
import DATA from "./tmData.js";
import {
  ClientsList,
  DeleteProject,
  getProjectList,
  getProjectTaskList,
  projectStatusUpdate,
  sendProjectEmail,
  SendProjectEmail,
} from "./Service/TaskService.js";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices.js";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import { TostMsg } from "../../../App.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { useHistory, useParams, useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import { ProjectModalContext } from "./Service/ProjectModalContext.jsx";

const TaskManagementProject = () => {
  const location = useLocation();
  // ── SORT OPTIONS ──
  const SORT_OPTIONS = [
    { label: "Modified On(Default)", value: "" },
    { label: "Project Name", value: "ProjectName" },
    { label: "Type", value: "ProjectTypeId" },
    { label: "Client", value: "ClientName" },
    { label: "Status", value: "ProjectStatusId" },
    { label: "Created On", value: "CreatedOn" },
    // { label: "Modified On", value: "ModifiedOn" },
    // { label: "Country", value: "CountryName" },
    { label: "Manager", value: "ManagerName" },
    { label: "Start Date", value: "StartDate" },
    { label: "End Date", value: "EndDate" },
  ];

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const { openAddProject, registerProjectSaveCallback } = useContext(ProjectModalContext);
  const [isArchConfirmOpen, setIsArchConfirmOpen] = useState(false);
  const [archiveProjectId, setArchiveProjectId] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [projectStatus, setProjectStatus] = useState([]);
  const [projectType, setProjectType] = useState([]);

  // ── Changed to arrays for MultiSelect ──
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [selectedType, setSelectedType] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState(searchQuery);
  const [filterStart, setFilterStart] = useState("");
  const [filterEnd, setFilterEnd] = useState("");
  const [loader, setLoading] = useState(true);

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");

  const [allProject, setAllProject] = useState([]);
  const [projectSummary, setProjectSummary] = useState({});
  const [projectTaskList, setProjectTaskList] = useState([]);
  const [projectTaskSummary, setProjectTaskSummary] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const history = useHistory();
  const { ClientGUID } = useParams();
  const [createProject, setCreateProject] = useState(false);
  const [isClientReady, setIsClientReady] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isEmailModal, setIsEmailModal] = useState(false);
  const [currentProject, setCurrentProject] = useState(null);

  const toggleSortOrder = () =>
    setSortOrder((prev) => (prev === "ASC" ? "DESC" : "ASC"));

  const hasActiveFilters =
    searchQuery ||
    selectedStatus?.length > 0 ||
    selectedClient?.length > 0 ||
    selectedType?.length > 0 ||
    filterStart ||
    filterEnd ||
    sortBy;

  useEffect(() => {
    registerProjectSaveCallback(() => allProjects(1, rows, searchQuery, selectedStatus, selectedType, filterStart, filterEnd, selectedClient, sortBy, sortOrder));
  }, [registerProjectSaveCallback, rows, searchQuery, selectedStatus, selectedType, filterStart, filterEnd, selectedClient, sortBy, sortOrder]);


  useEffect(() => {
    if (!isClientReady) return;
    allProjects(
      1, rows,
      searchQuery, selectedStatus, selectedType,
      filterStart, filterEnd, selectedClient,
      sortBy, sortOrder
    );
  }, [
    isClientReady,
    rows,
    ClientGUID,
    searchQuery,       // ← set by debounce above
    selectedStatus,
    selectedType,
    selectedClient,
    filterStart,
    filterEnd,
    sortBy,
    sortOrder,
  ]);

  useEffect(() => {
    async function initPage() {
      try {
        setLoading(true);
        await Promise.allSettled([
          getProjectStatusCategory(),
          getProjectTypeCategory(),
          getClientList(),
          GetMasterSystemAlertList(),
          permissionList(),
        ]);
      } finally {
        setLoading(false);
      }
    }
    initPage();
  }, [ClientGUID]);

  useEffect(() => {
    const id = setTimeout(() => {
      setSearchQuery(searchInput);
      setFirst(0);
    }, 900);
    return () => clearTimeout(id);
  }, [searchInput]);


  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName == "Project.Create") {
          setCreateProject(true);
        }
      });
    }
  };

  async function getClientList() {
    const params = {
      Id: 0,
      Guid: "",
      Search: "",
      PageNumber: 1,
      PageSize: 10000,
      CountryId: "",
      TotalProjects: 0,
      Status: 0,
      SortBy: "",
      SortOrder: ""
    };
    try {
      const response = await ClientsList(params);
      const clients = response?.Data || [];
      setClientList(clients);

      if (ClientGUID) {
        const matchedClient = clients.find(
          (client) => client?.Guid === ClientGUID || client?.GUID === ClientGUID
        );
        if (matchedClient) {
          const clientId = matchedClient?.Id || matchedClient?.ClientId || 0;
          setSelectedClient([clientId]);
        }
      }
      setIsClientReady(true);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsClientReady(true);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  async function allProjects(
    page = 1,
    size = rows,
    search = searchQuery,
    statusArr = selectedStatus,
    typeArr = selectedType,
    start = filterStart,
    end = filterEnd,
    clientArr = selectedClient,
    sortByVal = sortBy,
    sortOrderVal = sortOrder,
  ) {
    setLoading(true);

    let body = {
      Id: 0,
      StartDate: start || "",
      EndDate: end || "",
      ProjectStatusId: statusArr?.length > 0 ? statusArr.join(",") : "",
      ProjectTypeId: typeArr?.length > 0 ? typeArr.join(",") : "",
      ClientId: clientArr?.length > 0 ? clientArr.join(",") : "",
      PageNumber: page,
      PageSize: size,
      Search: search || "",
      SortBy: sortByVal || "",
      SortOrder: sortOrderVal || "",

    };

    try {
      let res = await getProjectList(body);
      setLoading(false);
      const projectList = res?.Data?.ProjectList || [];
      setAllProject(projectList);
      setProjectSummary(res.Data?.ProjectSummary);
      setTotalRecords(res?.Data?.TotalCount);
    } catch (error) {
      setLoading(false);
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setLoading(false);
    }
  }

  async function getProjectStatusCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "ProjectStatus",
      });
      setProjectStatus(data?.Data || []);
    } catch (error) {
      setLoading(false);
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getProjectTypeCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "ProjectType",
      });
      setProjectType(data?.Data || []);
    } catch (error) {
      setLoading(false)
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  async function getProjectsTaskList(projectId) {
    const params = {
      RaisedByEmpId: "",
      AssignedToId: "",
      TaskId: 0,
      StatusId: "",
      ModuleId: "",
      SubModuleId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1,
      PageSize: 5,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: projectId?.toString(),
      ParentTaskId: 0,
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    try {
      const response = await getProjectTaskList(params);
      setProjectTaskList(response?.Data?.OrgEmpTasks);
      setProjectTaskSummary(response?.Data?.TaskStatusCounts);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  const sBadge = (status) => {
    const map = { Active: "bg-success", Archived: "bg-Archived" };
    return map[status] || "bg-inprog";
  };

  const toggleSection = (section) => {
    if (section === "filter") setFilterOpen(!filterOpen);
    else if (section === "summary") setSummaryOpen(!summaryOpen);
  };

  const renderToggleArrow = (isOpen, color = "currentColor") => (
    <svg viewBox="0 0 20 20" width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" style={{ display: "block" }}>
      <path
        d={isOpen ? "M5 12l5-5 5 5" : "M5 7l5 5 5-5"}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const avHtml = (name, size = 24) => {
    const initial = name
      ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
      : "??";
    return `<div style="width:${size}px;height:${size}px;border-radius:50%;background:var(--brand-soft);color:var(--purple);display:flex;align-items:center;justify-content:center;font-size:${size / 2.2}px;font-weight:700">${initial}</div>`;
  };

  const fmtDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  };

  const renderOnTopSummary = () => {
    const { TotalProjects: total, ActiveProjects: active, ArchivedProjects: archived,
      PlannedProjects: planned, PausedProjects: paused, MaintenanceProjects: maintenance,
      CompletedProjects: completed } = projectSummary;
    return (
      <>
        <div className="sc r"><div className="sc-lab">Total</div><div className="sc-val">{total}</div></div>
        <div className="sc g"><div className="sc-lab">Active</div><div className="sc-val">{active}</div></div>
        <div className="sc gr"><div className="sc-lab">Archived</div><div className="sc-val">{archived}</div></div>
        <div className="sc gr"><div className="sc-lab">Planned</div><div className="sc-val">{planned}</div></div>
        <div className="sc gr"><div className="sc-lab">Paused</div><div className="sc-val">{paused}</div></div>
        <div className="sc gr"><div className="sc-lab">Maintenance</div><div className="sc-val">{maintenance}</div></div>
        <div className="sc gr"><div className="sc-lab">Completed</div><div className="sc-val">{completed}</div></div>
      </>
    );
  };

  const renderSummary = () => renderOnTopSummary();

  // ── Filter handlers ──
  const handleSearchChange = (value) => { setSearchInput(value); };

  const handleStatusChange = (value) => { setSelectedStatus(value); setFirst(0); };

  const handleClientChange = (value) => { setSelectedClient(value); setFirst(0); };

  const handleTypeChange = (value) => { setSelectedType(value); setFirst(0); };

  const handleStartChange = (value) => { setFilterStart(value); setFirst(0); };

  const handleEndChange = (value) => { setFilterEnd(value); setFirst(0); };

  const clearFilters = () => {
    setSearchQuery(""); setSearchInput("");
    setSelectedStatus([]); setSelectedType([]); setSelectedClient([]);
    setFilterStart(""); setFilterEnd("");
    setSortBy(""); setSortOrder("ASC");
    setFirst(0);
    // ↑ state changes trigger the useEffect — no allProjects() call needed
  };

  const openPanel = (project) => {
    setSelectedProject(project);
    getProjectsTaskList(project?.Id);
  };

  const closePanel = () => setSelectedProject(null);

  const selectedTasks = selectedProject
    ? DATA.tasks.filter((t) => t.projectId === selectedProject.Id)
    : [];
  const selectedDone = selectedTasks.filter(
    (t) => t.status === "Closed" || t.status === "Resolved"
  ).length;
  const selectedPct = selectedTasks.length
    ? Math.round((selectedDone / selectedTasks.length) * 100)
    : 0;

  const statusBreakdown = (() => {
    if (!selectedProject?.Id || !Array.isArray(projectTaskSummary)) return [];
    return projectTaskSummary?.map((s) => ({ l: s.Status, v: s.TaskCount }));
  })();

  const [spDescExpanded, setSpDescExpanded] = useState(false);

  const [selectedDeleteId, setSelectedDeleteId] = useState(0);
  const [isDeletedModal, setDeletedModal] = useState(false);

  const editProject = (editProjectData) => {
    openAddProject(editProjectData);
  };

  const askArchive = (id) => {
    setArchiveProjectId(id);
    setIsArchConfirmOpen(true);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    // For page changes you still need a direct call since `page` isn't in state:
    allProjects(event.page + 1, event.rows);
  };



  const askDeleteConfirm = (projectId) => {
    setDeletedModal(true);
    setSelectedDeleteId(projectId);
  };

  async function deleteProject() {
    try {
      const response = await DeleteProject({ Id: selectedDeleteId });
      if (response?.StatusCode === 2000) {
        GetMasterSystemAlertList("Project_Delete", 0);
        setDeletedModal(false);
        allProjects(1, rows);
      } else {
        toster.current.error(response.Data?.Message || "somthing went wrong");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  async function archiveProject() {
    try {
      const response = await projectStatusUpdate({ ProjectId: archiveProjectId, ProjectStatusId: 106 });
      if (response?.StatusCode === 2000) {
        setIsArchConfirmOpen(false);
        setArchiveProjectId(0);
        allProjects(1, rows);
        GetMasterSystemAlertList("Project_Archive", 0);
      } else {
        toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  const projectDetail = (id) => {
    window.open(`/Project/Detail/${id}`, "_blank");
  };

  async function sendEmailToProject() {
    const params = {
      projectId: currentProject?.Id,
    };
    setLoading(true);
    try {
      const response = await sendProjectEmail(params);
      setIsEmailModal(false);
      setLoading(false);
      toster.current.success(
        response?.Message
      );
    } catch (error) {
      setLoading(false);
      toster.current.error(
        error?.response?.Message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="">
      <div className="task-top-pane">
        <i className="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="page-head">
          <div>
            <h2>Projects</h2>
            <div className="topbar-sub" id="projCount">
              <>
                {projectSummary?.TotalProjects || 0}{" "}
                {projectSummary?.TotalProjects > 1 ? "projects" : "project"}
                {(projectSummary?.PrivateProjects > 0 || projectSummary?.PublicProjects > 0) && (
                  <>
                    {" ("}
                    {projectSummary?.PrivateProjects > 0 && <>Private: {projectSummary?.PrivateProjects}</>}
                    {projectSummary?.PrivateProjects > 0 && projectSummary?.PublicProjects > 0 && " "}
                    {projectSummary?.PublicProjects > 0 && <>Public: {projectSummary?.PublicProjects}</>}
                    {")"}
                  </>
                )}
              </>
            </div>
          </div>
          <div className="head-actions">
            {createProject && (
              <button className="btn btn-brand btn-sm" onClick={() => openAddProject()}>
                <i className="fa-solid fa-plus"></i> New Project
              </button>
            )}
            <Link
              to="/Project/Dashboard"
              className="btn-og btn-og-secondary btn-og-sm"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
              </svg>
            </Link>
          </div>
        </div>

        <div className="page">
          {/* SUMMARY COLLAPSIBLE SECTION */}
          <div className="collapsible-section" id="summarySection">
            <div className="section-toggle summery-box-label" onClick={() => toggleSection("summary")}>
              <div className="section-toggle-icon icon-summary">
                <svg viewBox="0 0 28 28" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <rect width="28" height="28" rx="8" fill="none" />
                  <rect x="7" y="15" width="4" height="7" rx="1" fill="#1a56db" />
                  <rect x="12" y="11" width="4" height="11" rx="1" fill="#1a56db" />
                  <rect x="17" y="7" width="4" height="15" rx="1" fill="#1a56db" />
                </svg>
              </div>
              <span className="section-label">Summary</span>
              {!summaryOpen && (renderOnTopSummary())}
              <span className="section-hint" id="summaryHint">Project Overview</span>
              <div className={`section-toggle-arrow ${summaryOpen ? "open" : ""}`} id="summaryChevron" style={{ color: "#1a56db" }}>

                {renderToggleArrow(summaryOpen, "#1a56db")}
              </div>
            </div>
            <div className={`section-body ${summaryOpen ? "open" : ""}`} id="summaryBody">
              <div className="section-body-inner" onClick={(e) => e.stopPropagation()}>
                <div className="sstrip" id="sumStrip">{renderSummary()}</div>
              </div>
            </div>
          </div>

          {/* FILTER COLLAPSIBLE SECTION */}
          <div className="collapsible-section" id="filterSection" onClick={() => toggleSection("filter")}>
            <div className="section-toggle">
              <div className="section-toggle-icon icon-filter">
                <svg viewBox="0 0 28 28" width="28" height="28" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <rect width="28" height="28" rx="8" fill="#f0fdf4" />
                  <path d="M7 9.5h14M9.5 14h9M12 18.5h4" stroke="#15803d" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </div>
              <span className="section-label" onClick={() => toggleSection("filter")}>Filters</span>
              <div className={`section-toggle-arrow ${filterOpen ? "open" : ""}`} id="filterChevron" style={{ color: "#15803d" }}>
                <div className="sort-bydiv" onClick={(e) => e.stopPropagation()}>
                  {/* ── Sort By dropdown ── */}
                  <label style={{ fontSize: "11px", color: "var(--muted)", whiteSpace: "nowrap", marginBottom: "0" }}>Sort By:</label>
                  <select
                    className="fs"
                    style={{ width: "auto" }}
                    value={sortBy}
                    onChange={(e) => { setSortBy(e.target.value); setSortOrder("ASC"); }}
                  >
                    {SORT_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>

                  {/* ── ASC / DESC toggle button ── */}
                  <button
                    type="button"
                    className="btn btn-ghost btn-icon btn-sm"
                    title={sortOrder === "ASC" ? "Ascending — click for Descending" : "Descending — click for Ascending"}
                    onClick={toggleSortOrder}
                    disabled={!sortBy}
                    style={{
                      opacity: sortBy ? 1 : 0.35,
                      cursor: sortBy ? "pointer" : "not-allowed",
                      fontSize: "13px",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid var(--border)",
                      borderRadius: "var(--radius)",
                      background: sortBy ? "var(--card)" : "transparent",
                      transition: "all 0.15s",
                    }}
                  >
                    {sortOrder === "ASC"
                      ? <i className="fa-solid fa-arrow-up-a-z"></i>
                      : <i className="fa-solid fa-arrow-down-z-a"></i>}
                  </button>
                </div>
                {renderToggleArrow(filterOpen, "#15803d")}

              </div>
            </div>

            <div className={`section-body ${filterOpen ? "open" : ""}`} id="filterBody">
              <div className="section-body-inner" onClick={(e) => e.stopPropagation()}>
                <div
                  className="toolbar">
                  <div className="toolbar-sepdiv">
                    {/* Search */}
                    <div className="sw" style={{ flex: "2 1 220px", minWidth: 180 }}>
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        className="si"
                        id="searchInp"
                        placeholder="Search projects…"
                        value={searchInput}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="tsep"></div>

                    {/* Client — MultiSelect */}
                    <MultiSelect
                      value={selectedClient}
                      onChange={(e) => handleClientChange(e.value)}
                      options={clientList}
                      optionLabel="ClientName"
                      optionValue="Id"
                      placeholder="Select Client"
                      filter
                      style={{ flex: "1 1 140px", minWidth: 130 }}
                    />

                    {/* Status — MultiSelect */}
                    <MultiSelect
                      value={selectedStatus}
                      onChange={(e) => handleStatusChange(e.value)}
                      options={projectStatus}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Status"
                      filter
                      style={{ flex: "1 1 130px", minWidth: 120 }}
                    />

                    {/* Type — MultiSelect */}
                    <MultiSelect
                      value={selectedType}
                      onChange={(e) => handleTypeChange(e.value)}
                      options={projectType}
                      optionLabel="Name"
                      optionValue="Id"
                      placeholder="All Types"
                      filter
                      style={{ flex: "1 1 130px", minWidth: 120 }}
                    />


                    <div className="tsep"></div>
                  </div>
                  <div className="toolbar-sepdiv">
                    <label style={{ fontSize: "11px", color: "var(--muted)", whiteSpace: "nowrap", marginBottom: "0" }}>From:</label>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "126px" }}
                      id="fStart"
                      value={filterStart}
                      onChange={(e) => handleStartChange(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker &&
                        e.target.showPicker()
                      }
                    />
                    <label style={{ fontSize: "11px", color: "var(--muted)", whiteSpace: "nowrap", marginBottom: "0" }}>To:</label>
                    <input
                      type="date"
                      className="fc"
                      style={{ width: "126px" }}
                      id="fEnd"
                      value={filterEnd}
                      onChange={(e) => handleEndChange(e.target.value)}
                      onClick={(e) =>
                        e.target.showPicker &&
                        e.target.showPicker()
                      }
                    />

                    <div className="tsep"></div>

                    <button
                      className="btn btn-ghost btn-sm"
                      onClick={clearFilters}
                      disabled={!hasActiveFilters}
                      title="Clear all filters"
                      style={{
                        opacity: hasActiveFilters ? 1 : 0.4,
                        cursor: hasActiveFilters ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i> Clear
                    </button>
                  </div>

                  {/* <span style={{ fontSize: "11.5px", color: "var(--muted)" }} id="fCount">
                      {allProject.length} / {projectSummary?.TotalProjects}
                    </span> */}
                </div>
              </div>
            </div>
          </div>

          <div className="flex" style={{ flex: "1" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", overflowY: "hidden" }}>
              {/* Projects Table */}
              <div className="height-body-equal">
                <table className="dtbl" id="projTable">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Project ID</th>
                      <th>Last Note</th>
                      <th>Start-End</th>
                      <th style={{ width: "120px" }}>Members</th>
                      <th>Tasks Progress</th>
                      <th>Status</th>
                      <th className="task-actions-header">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allProject?.length > 0 ? (
                      allProject?.map((p) => (
                        <tr
                          key={p.Id}
                          onClick={() => openPanel(p)}
                          className={`${selectedProject?.Id === p?.Id ? "row-selected" : ""}`}
                          style={{
                            cursor: "pointer",
                            background: selectedProject?.Id === p?.Id ? "var(--brand-soft, rgba(236,65,25,0.08))" : "",
                            borderLeft: selectedProject?.Id === p?.Id ? "3px solid var(--brand)" : "3px solid transparent",
                            transition: "background 0.15s, border-left 0.15s",
                          }}
                        >
                          <td className="title-cell" onClick={() => openPanel(p)} style={{ cursor: "pointer" }}>
                            <p className="mb-0 task-headingp" style={{ fontWeight: 600 }}>  <span className="lock-icon"
                              title={p.IsPublic ? "Public" : "Private"} style={{ marginRight: "4px", marginLeft: "0" }}>
                              <i
                                className={`fa-solid ${p.IsPublic ? "fa-lock-open" : "fa-lock"}`}
                              ></i>
                            </span>{p.Name || p.ProjectName || "N/A"} {p.ProjectSlug && `(${p.ProjectSlug})`}

                            </p>
                            {(p.ClientName || p.ClientId) && (
                              <p className="module-status">
                                <span>{p.ClientName?.length > 65
                                  ? p.ClientName.slice(0, 65) + "..."
                                  : p.ClientName || "N/A"}


                                </span>
                                <span>| </span>
                                <span>{p.ProjectType || "N/A"}</span>
                                <span>| </span>
                                <span className="w-s table-profile"
                                  onClick={() => {
                                    if (p?.ManagerGUID) {
                                      window.open(`/Profile/${p.ManagerGUID}`, "_blank");
                                    }
                                  }}

                                  title="Manager"> {p?.ManagerId > 0 ? (
                                    <>
                                      <LazyImage alt={p.ManagerName} src={p.ManagerImage} />
                                      {p?.ManagerName}
                                    </>
                                  ) : (
                                    <>
                                      <img src="/images/placeholder_profile.png" width="20" />
                                      <span>N/A</span>
                                    </>
                                  )}</span>
                              </p>
                            )}
                          </td>
                          <td>
                            <b class="task-number-td">
                              {p.ProjectCode}
                            </b>
                          </td>
                          <td>{p?.ProjectContactNoteList?.[0]?.Notes || "N/A"}</td>
                          <td className="w-s" style={{ fontSize: "11.5px" }}>
                            {fmtDate(p.StartDate || "N/A")}<br />
                            {p?.EndDate === "1900-01-01 05:30:00" ? "N/A" : fmtDate(p?.EndDate)}
                          </td>
                          <td>
                            {p?.ProjectMemberList?.length > 0 ? (
                              <div className="flex gap2 align-items-center">
                                {(p.ProjectMemberList || []).slice(0, 3).map((member, i) => (
                                  <div
                                    key={i}
                                    className="member-chip"
                                    title={member?.EmployeeName || "Unknown"}
                                  >
                                    {member?.EmployeeGUID ? (
                                      <a
                                        href={`/Profile/${member.EmployeeGUID}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <LazyImage
                                          alt={member?.EmployeeName || "Member"}
                                          src={member?.ProfileImage}
                                          width="10px"
                                        />
                                      </a>
                                    ) : (
                                      <LazyImage
                                        alt={member?.EmployeeName || "Member"}
                                        src={member?.ProfileImage}
                                        width="10px"
                                      />
                                    )}
                                  </div>
                                ))}

                                {p.ProjectMemberList.length > 4 && (
                                  <div className="more-count">
                                    +{p.ProjectMemberList.length - 3}
                                  </div>
                                )}
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>
                            {p.TaskCount}<br />
                            <div className="flex ic gap5" style={{ width: "50%" }}>
                              <div className="pbar">
                                <div className="pfill" style={{ width: `${p.ProgressPercentage}%` }}></div>
                              </div>
                              <span style={{ fontSize: "11px", fontWeight: 700 }}>{p.ProgressPercentage}%</span>
                            </div>
                          </td>
                          <td>
                            <span className={`badge ${sBadge(p?.ProjectStatus)}`}>
                              {p?.ProjectStatus || "N/A"}
                            </span>
                          </td>
                          <td className="task-actions-cell" onClick={(e) => e.stopPropagation()}>
                            <div className="flex gap4 task-actions">
                              {createProject && (
                                <>
                                  <button className="btn btn-ghost btn-icon" onClick={() => editProject(p)} title="Edit">
                                    <i className="fa-solid fa-pen"></i>
                                  </button>
                                  <button
                                    className="btn btn-ghost btn-icon"
                                    onClick={() => {
                                      setIsEmailModal(true);
                                      setCurrentProject(p);
                                    }}
                                    title="Send Email"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                                      <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                    </svg>
                                  </button>
                                  <button className="btn btn-ghost btn-icon" onClick={() => askArchive(p.Id)} title="Archive">
                                    <i className="fa-solid fa-archive"></i>
                                  </button>
                                </>
                              )}
                              <Link onClick={() => {
                                window.open(
                                  `/Project/Tasks/${p.GUID}`,
                                  "_blank"
                                );
                              }} title="View Tasks" className="btn btn-ghost btn-icon">
                                <i className="fa-solid fa-eye"></i>
                              </Link>
                              {createProject && (<button
                                className="btn btn-ghost btn-icon"
                                style={{ color: "var(--red)" }}
                                onClick={() => askDeleteConfirm(p.Id)}
                                title="Delete"
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>)}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>No projects found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* <div className="sticky-footer">
                  <div className="card">
                   
                  </div>
                </div> */}
              </div>
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalRecords}
                rowsPerPageOptions={[50, 100, 200, 500]}
                onPageChange={onPageChange}
              />
              <div style={{ height: "14px" }}></div>
            </div>

            {/* Side Panel */}
            <div
              className={`sp${selectedProject ? " open" : ""}`}
              id="sidePanel"

            >
              {selectedProject && (
                <>
                  <div className="sp-hd">
                    <h5>{selectedProject.Name}</h5>
                    {createProject && (
                      <>
                        <button className="btn btn-ghost btn-icon" onClick={() => { closePanel(); editProject(selectedProject); }} title="Edit">
                          <i className="fa-solid fa-pen"></i>
                        </button>
                        <button className="btn btn-ghost btn-icon" onClick={() => askArchive(selectedProject.id)} title="Archive">
                          <i className="fa-solid fa-archive"></i>
                        </button>
                      </>
                    )}
                    <Link
                      className="btn btn-ghost btn-icon"
                      onClick={() => projectDetail(selectedProject?.GUID)}
                      rel="noopener noreferrer"
                      title="Open full detail"
                    >
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </Link>
                    <button className="btn btn-ghost btn-icon" onClick={closePanel}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                  <div className="sp-bd" style={{ padding: "16px", overflowY: "auto", flex: 1, scrollbarWidth: "none" }}>
                    <div className="flex ic gap6" style={{ flexWrap: "wrap", marginBottom: "12px" }}>
                      <span className={`badge ${sBadge(selectedProject?.ProjectStatus)}`}>
                        {selectedProject?.ProjectStatus}
                      </span>
                      <code>
                        {selectedProject?.ProjectCode}
                      </code>
                      {selectedProject?.ProjectType && (
                        <span style={{ fontSize: "11px", color: "var(--mid)" }}>{selectedProject?.ProjectType}</span>
                      )}
                    </div>

                    <div className="ql-editor project-task-description">
                      <div dangerouslySetInnerHTML={{ __html: selectedProject?.Desc || "<p>No description</p>" }} />
                    </div>

                    <div className="set-horizontal2">
                      {selectedProject.ClientName && (
                        <div style={{ border: "2px solid var(--brand-soft)", borderRadius: "10px", padding: "12px 14px", marginBottom: "14px", height: "-webkit-fill-available" }}>
                          <div style={{ fontSize: "10px", fontWeight: 700, textTransform: "uppercase", color: "var(--brand)", letterSpacing: "0.5px", marginBottom: "6px", display: "flex", alignItems: "center", gap: "5px" }}>
                            <i className="fa-solid fa-building" style={{ fontSize: "11px" }}></i> CLIENT
                          </div>
                          <div style={{ fontWeight: 700, fontSize: "14px", marginBottom: "2px" }}>{selectedProject?.ClientName}</div>
                        </div>
                      )}
                      <div style={{ display: "grid", gridTemplateColumns: "1fr", rowGap: "10px", marginBottom: "14px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div className="sidedrawer-title mb-0">From - To</div>
                          <div style={{ fontWeight: 700, fontSize: "13px", color: "black" }}>{fmtDate(selectedProject?.StartDate)} -  {selectedProject?.EndDate === "1900-01-01 05:30:00" ? "" : fmtDate(selectedProject?.EndDate)}</div>
                        </div>
                      </div>
                    </div>

                    <div className="set-horizontal mb-2">
                      <div>
                        <div className="flex ic" style={{ marginBottom: "6px" }}>
                          <span className="sidedrawer-title">PROGRESS</span>
                        </div>
                        <div className="pbar" style={{ height: "7px" }}>
                          <div className="pfill" style={{ width: `${selectedProject?.ProgressPercentage}%` }}></div>
                        </div>
                      </div>
                      <div style={{ marginLeft: "auto" }}>
                        <div className="sidedrawer-title">
                          TEAM ({selectedProject?.ProjectMemberList?.length || 0})
                        </div>
                        <div className="flex ic gap1" style={{ flexWrap: "wrap" }}>
                          {selectedProject?.ProjectMemberList?.slice(0, 6)?.map((m, i) => (
                            <div key={m?.Id} className="member-chip">
                              {m?.EmployeeGUID ? (
                                <Link to={`/Profile/${m.EmployeeGUID}`}>
                                  <LazyImage
                                    alt={m?.EmployeeName}
                                    src={m?.ProfileImage}
                                    width="20px"
                                  />
                                </Link>
                              ) : (
                                <LazyImage
                                  alt={m?.EmployeeName}
                                  src={m?.ProfileImage}
                                  width="20px"
                                />
                              )}
                            </div>
                          ))}
                          {selectedProject?.ProjectMemberList?.length > 6 && (
                            <div className="more-count">+{selectedProject?.ProjectMemberList?.length - 6}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "4px", marginBottom: "16px" }}>
                      {statusBreakdown.map((s, i) => (
                        <div key={i} style={{ flex: 1, textAlign: "center", background: "#f8f9fa", borderRadius: "8px", padding: "8px 4px" }}>
                          <div style={{ fontWeight: 700, fontSize: "16px" }}>{s.v}</div>
                          <div style={{ fontSize: "9.5px", color: "var(--muted)", whiteSpace: "nowrap" }}>{s.l}</div>
                        </div>
                      ))}
                    </div>

                    <div>
                      <div className="sidedrawer-title">
                        RECENT TASKS
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        {projectTaskList?.map((t, i) => (
                          <div key={i} className="flex ic gap6" style={{ padding: "6px 8px", background: "#f8f9fa", borderRadius: "7px" }}>
                            <span className={`badge ${sBadge(t.StatusName)}`} style={{ fontSize: "10px", padding: "2px 7px" }}>
                              {t.StatusName}
                            </span>
                            <span style={{ fontSize: "12px", fontWeight: 500, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", flex: 1 }}>
                              {t.TaskTitle}
                            </span>
                          </div>
                        ))}
                        {projectTaskList?.length === 0 && (
                          <div style={{ color: "var(--muted)", fontSize: "12px", padding: "8px", textAlign: "center" }}>No tasks yet</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* <div className="sp-ft" style={{ padding: "12px 16px", borderTop: "1px solid var(--border-lt)", display: "flex", gap: "8px", alignItems: "center" }}>
                    <Link
                      onClick={() => projectDetail(selectedProject?.GUID)}
                      className="btn btn-brand btn-sm"
                      style={{ flex: 1, textAlign: "center", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "6px", textDecoration: "none" }}
                    >
                      <i className="fa-solid fa-arrow-right"></i> Full Detail
                    </Link>
                    
                  </div> */}
                </>
              )}
            </div>
          </div>
        </div>
      </div>



      {/* Delete Confirm */}
      {isDeletedModal && (
        <div className="modal show" id="delete-project-confirm" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img src="/images/org-img/leave/popup-backimg.png" className="backimg" />
                <div className="img"><img src="/images/org-img/leave/trash.png" /></div>
              </div>
              <div className="modal-body text-center"><p>Are you sure you want to delete this project?</p></div>
              <div className="modal-footer m-auto">
                <button type="button" className="cancelbtn-click" onClick={() => setDeletedModal(false)}>Cancel</button>
                <button type="button" className="deletebtn-click" onClick={() => deleteProject()}>Continue</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Archive Confirm */}
      {isArchConfirmOpen && (
        <div className="modal show" id="archive-project-confirm" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img src="/images/org-img/leave/popup-backimg.png" className="backimg" />
                <div className="img"><i className="fa-solid fa-archive fs-18 text-primary"></i></div>
              </div>
              <div className="modal-body text-center">
                <p>Archive this project? It will be hidden from active views but tasks will be preserved.</p>
              </div>
              <div className="modal-footer m-auto">
                <button type="button" className="cancelbtn-click" onClick={() => setIsArchConfirmOpen(false)}>Cancel</button>
                <button type="button" className="deletebtn-click" onClick={() => archiveProject()}>Archive</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Email Confirmation */}
      {isEmailModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to send an email to this project?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setIsEmailModal(false);

                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => {

                    sendEmailToProject();
                    // Proceed with sending email
                  }}
                >
                  Send Email
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {loader ? <Suspense><ComponentLoader /></Suspense> : ""}
    </div>
  );
};

export default TaskManagementProject;